// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"16ae7beb","453":"a76944ba","918":"bb809e2b"}[chunkId] + ".chunk.js";
};